import React from 'react';
import { faFileInvoiceDollar, faMoneyBillTransfer, faMoneyCheck } from '@fortawesome/pro-duotone-svg-icons';
import Button from '../common/Button';
import { useRouter } from 'next/navigation';
import { SubscriptionTier } from '@/actions/dtos/subscription';
import { BillingPeriod } from '@/types/billingPeriod';
import Modal from '@/components/common/Modal';
import { getSourcePath } from '@/rewrites';

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  subscriptionTier: SubscriptionTier;
  billingPeriod: BillingPeriod;
  discountCode?: string;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  isOpen,
  onClose,
  subscriptionTier,
  billingPeriod,
  discountCode,
}) => {
  const router = useRouter();

  const handleInvoiceButtonClick = () => {
    if (subscriptionTier && billingPeriod) {
      const query = new URLSearchParams({
        subscriptionTier: subscriptionTier,
        billingPeriod: billingPeriod,
      });
      if (discountCode) {
        query.append('discountCode', discountCode);
      }

      router.push(getSourcePath('/invoice') + `?${query.toString()}`);
    }
  };

  const handleStripeButtonClick = async () => {
    const url = new URL(`/checkout`, window.location.origin);
    url.searchParams.set('tier', subscriptionTier);
    url.searchParams.set('period', billingPeriod);
    if (discountCode) {
      url.searchParams.set('discountCode', discountCode);
    }
    router.push(url.toString());
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={'Zahlungsart:'}>
      <div className="flex max-md:flex-col max-md:space-y-2 md:space-x-4">
        <Button icon={faMoneyCheck} label="Kreditkarte" onClick={handleStripeButtonClick} />
        <Button icon={faMoneyBillTransfer} label="SEPA Lastschrift" onClick={handleStripeButtonClick} />
        <Button icon={faFileInvoiceDollar} label="Auf Rechnung" onClick={handleInvoiceButtonClick} />
      </div>
    </Modal>
  );
};

export default PaymentModal;
